export default __webpack_public_path__ + "static/media/selectedLanguage-light.935a1fc7.svg";